// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import Moment from 'moment'
import Cookies from 'js-cookie'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'lib-flexible/flexible'
import 'mint-ui/lib/style.css'
import './common/font/font.css'

// import vueSwiper from 'vue-awesome-swiper'

import 'swiper/dist/css/swiper.css' //引入样式

Vue.prototype.moment = Moment
Vue.use(Cookies)
Vue.use(MintUI)
Vue.use(ElementUI)
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router, //使用上vue-router
  // store, // 使用上vuex
})



// WEBPACK FOOTER //
// ./src/main.js